import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { dynamicQueryService } from "../services/svc_dynamicquery";
import { queryKeys } from "../lib/queryKeys";
import {
  DynamicQueryResponse,
  DynamicRequestSchema,
} from "../types/dynamicQueryTypes";

export const useTSQDynamicList = (
  params: DynamicRequestSchema,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: queryKeys.dynamic.list(params),
    queryFn: () => dynamicQueryService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
    refetchOnMount: "always",
  });
};
